import { ConfirmSwapDialogComponent } from './confirm-swap-dialog/confirm-swap-dialog.component';
import { CryptoService } from './../../abstraction/crypto.service';
import { MatDialog } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ICryptoPortfolio, ICryptoPrice, ICryptoPrices } from '../../models/Crypto';
import { AuthService } from '../../abstraction/auth.service';
import { COIN_TYPE, IOrderStatus, OPERATION_TYPE } from '../../models/Order';
import BigNumber from 'bignumber.js';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-swap',
  templateUrl: './swap.component.html',
  styleUrls: ['./swap.component.scss'],
})
export class SwapComponent implements OnInit {
  cryptoBalances: { [coin: string]: string } = {};
  cryptoPrices: ICryptoPrices = {};
  srcCoin = 'USDT';
  destCoin = 'ETH';
  currentCoinPair = 'ETH_USDT';
  currentPrice: ICryptoPrice;
  srcCoinSelectorOpened = false;
  destCoinSelectorOpened = false;
  srcValueControl: FormControl = new FormControl('', [Validators.required]);
  destValueControl: FormControl = new FormControl('', [Validators.required]);
  availableCoins: string[] = [];

  constructor(
    public cryptoService: CryptoService,
    private authService: AuthService,
    private titleService: Title,
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle('TiendaCrypto | Swap');
    this.authService.sendTikTokPageView(window.location.href).subscribe();
    this.cryptoService.prices.subscribe((prices) => {
      this.cryptoPrices = prices;
    });
    this.authService.myCryptoPortfolio.subscribe((balances: ICryptoPortfolio[]) => {
      const balanceObj = {};
      balances.forEach((balance) => {
        balanceObj[balance.ticker.toUpperCase()] = balance.stocks;
      });
      this.cryptoBalances = balanceObj;
    });
    this.cryptoService.availableSwapCoins.subscribe((coins) => {
      this.availableCoins = coins.sort((a, b) => {
        if (a === 'USDT') return -1;
      });
    });
  }

  closeCoinSelector() {
    this.srcCoinSelectorOpened = false;
    this.destCoinSelectorOpened = false;
  }
}
